import Cookies from 'js-cookie';
import { PIANO_AUTH_CRED  } from "lib/constants"

export const getToken = () => {
  if (typeof window === undefined) {
    return null;
  }
  const cook = Cookies.get(PIANO_AUTH_CRED);
  return Cookies.get(PIANO_AUTH_CRED);
};
